import {Navigate, Outlet} from "react-router-dom";
import {useSelector} from "react-redux";
import {RootState} from "../store/store";
import React from "react";

interface ProtectedRouteProps {
    isProtected?: boolean;
    requireSuperuser?: boolean;
    redirectIfAuthenticated?: boolean;
    element?: React.ReactElement;
}

const ProtectedRoute = ({
                            isProtected = true,
                            requireSuperuser = false,
                            redirectIfAuthenticated = false,
                            element,
                        }: ProtectedRouteProps) => {
    const user = useSelector((state: RootState) => state?.user?.user);

    // For public routes like /signin
    if (redirectIfAuthenticated && user) {
        return <Navigate to="/admin/dashboard" replace/>;
    }

    // For protected routes
    if (isProtected && !user) {
        return <Navigate to="/signin" replace/>;
    }

    // Superuser check
    if (requireSuperuser && !user?.isSuperuser) {
        return <Navigate to="/admin/dashboard" replace/>;
    }

    return element ? element : <Outlet/>;
};

export default ProtectedRoute;
